import { CountDown, Progress } from 'react-vant';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Popup } from 'react-vant';
import LevelRule from 'components/level-rule';
import { formaTimeForTsToH, getArgFromUrl, sprintf } from 'utils';
import { useAtom } from 'jotai';
import {
  guildIdAtom,
  giftConfigAtom,
  selectUserDataAtom,
  masterInfoAtom,
  coinConfigAtom,
  salaryConfigAtom,
  dateTypeAtom,
  countdownAtom,
} from 'store';
import { giftFlowConfig, coinFlowConfig, salaryConnfig, membersDetailList } from 'api';
import { MasterSalary, MemberSalary, FlowItem, MembersDetailType } from 'api/type';
import LevelProgress from 'components/level-progress';
import { formatMonth, _T } from '@dana/components';

export const Card: React.FC<{
  type?: 'small' | 'big';
  name: string;
  value: string | number;
  isQ?: boolean;
  qClick?: () => void;
  onClick?: () => void;
  showArrow?: boolean;
}> = ({ name, value, isQ, qClick, type = 'small', onClick, showArrow }) => {
  const go = () => {
    if (onClick) {
      onClick();
    } else if (isQ && qClick) {
      qClick();
    }
  };

  return (
    <div
      className={`${type === 'small' ? 'w-[101px]' : 'w-[152px]'} relative flex flex-col justify-center items-center h-[62px] rounded-lg bg-[#F5F7F7]`}
      onClick={go}
    >
      <div className="text-[#B3B3B3] text-center font-sans text-[10px] font-semibold" dir="auto">
        {name}
      </div>
      <div className="text-[#16B28D] font-sans text-[16px] font-bold" dir="auto">
        {value}
      </div>
      {isQ && (
        <div
          className="absolute w-[12px] h-[12px] right-[12px] bottom-[20px] bg-cover"
          style={{
            backgroundImage: `url(${require('asset/imgs/q.png')})`,
          }}
        ></div>
      )}
      {showArrow && (
        <div
          className="absolute w-[14px] h-[14px] right-[8px] top-[50%] transform translate-y-[-50%] bg-cover"
          style={{
            backgroundImage: `url(${require('asset/imgs/right.png')})`,
          }}
        ></div>
      )}
    </div>
  );
};

export const getLvFromFloat = (giftFlow: FlowItem[], nowValue: number) => {
  const n = Math.floor(nowValue / 100);
  let result = {
    value: 0,
    nextValue: 0,
    level: 0,
  };
  giftFlow.forEach((item, index) => {
    let prevValue = index > 0 ? giftFlow[index - 1]?.flowTotal : 0;
    if (n >= prevValue && n < item?.flowTotal) {
      result = {
        value: n,
        nextValue: item?.flowTotal,
        level: giftFlow[index - 1]?.id,
      };
    }
  });
  if (n >= giftFlow[giftFlow.length - 1]?.flowTotal) {
    result = {
      value: n,
      nextValue: giftFlow[giftFlow.length - 1]?.flowTotal,
      level: giftFlow[giftFlow.length - 1]?.id,
    };
  }
  return result;
};

const DataDetails: React.FC<{
  type: 'master' | 'member';
  masterData: MasterSalary | undefined;
  memberData: MemberSalary | undefined;
  detailList: any[];
  date: string;
  isCurrentDate: boolean;
}> = (props) => {
  const { type, date, isCurrentDate, masterData, memberData, detailList } = props;

  const [dateType] = useAtom(dateTypeAtom);
  const [popup, setP] = useState(false);
  const [popup2, setP2] = useState(false);
  const [giftFlow, setGiftFlow] = useAtom(giftConfigAtom);
  const [coinFlow, setCoinFlow] = useAtom(coinConfigAtom);
  const [salaryFlow, setSalaryFlow] = useAtom(salaryConfigAtom);
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useAtom(selectUserDataAtom);
  const [masterInfo] = useAtom(masterInfoAtom);
  const [ruleType, setRuleType] = useState<'coin' | 'gift' | 'salary'>('coin');
  const [ruletitle, setRuleTitle] = useState('');
  // const [detailList, setDetailList] = useState<MembersDetailType[]>()
  const [progressV, setProgressV] = useState({
    value: 0,
    level: 0,
    nextValue: 0,
  });

  const [countDown] = useAtom(countdownAtom);

  const fetGiftConfig = async () => {
    let res = await giftFlowConfig(date, dateType === 'HALF_MONTH');
    if (res) {
      setGiftFlow(res);
    }
  };

  const fetCoinConfig = async () => {
    let res = await coinFlowConfig(date, dateType === 'HALF_MONTH');
    if (res) {
      setCoinFlow(res);
    }
  };

  const fetSalaryConfig = async () => {
    let res = await salaryConnfig(date, dateType === 'HALF_MONTH');
    if (res) {
      setSalaryFlow(res);
    }
  };

  useEffect(() => {
    if (memberData && giftFlow && memberData?.anchorFlowSalary?.giftFlowTotal) {
      const c = getLvFromFloat(giftFlow, memberData.anchorFlowSalary?.giftFlowTotal);
      setProgressV((prevState) => JSON.parse(JSON.stringify(c)));
    } else {
      setProgressV((prevState) =>
        JSON.parse(
          JSON.stringify({
            value: 0,
            level: 0,
            nextValue: 0,
          }),
        ),
      );
    }
  }, [giftFlow, memberData]);

  // useEffect(() => {
  //     fetGiftConfig()
  //     fetCoinConfig()
  //     fetSalaryConfig()
  //     fetchDetailList()
  // }, [])

  useEffect(() => {
    setProgressV((prevState) =>
      JSON.parse(
        JSON.stringify({
          value: 0,
          level: 0,
          nextValue: 0,
        }),
      ),
    );
    // fetchDetailList()
    fetGiftConfig();
    fetCoinConfig();
    fetSalaryConfig();
  }, [date]);

  // async function fetchDetailList() {
  //     const id = getArgFromUrl('uid') || ''
  //     const res = await membersDetailList (masterInfo?.guildId || 0, date, dateType === 'HALF_MONTH')
  //     if (res) {
  //         setDetailList(res)
  //     }
  // }

  function goToTime() {
    // const id = getArgFromUrl('uid') || ''
    // const data = detailList?.find(item => Number(item.memberId) === Number(id))
    // setUserInfo({
    //     // danaId: data?.danaId || 0,
    //     uid: Number(id) || 0,
    //     totalTime: data?.inVoiceTotal || 0,
    //     day: data?.activeDayTotal || 0,
    //     nickName: data?.nickName || '',
    //     avatar: data?.avatar || '',
    //     date: date
    // })
    navigate('/time');
  }

  function changeRuleType(type: 'coin' | 'gift' | 'salary', title: string) {
    setRuleTitle(title);
    setRuleType(type);
    setTimeout(() => {
      setP(true);
    });
  }

  function getConfig() {
    return ruleType === 'coin' ? coinFlow : ruleType === 'gift' ? giftFlow : salaryFlow;
  }

  function getProgress() {
    if (progressV.value === 0) {
      return 0;
    }
    return Number((progressV.value / progressV.nextValue).toFixed(2)) * 100 > 100
      ? 100
      : Number((progressV.value / progressV.nextValue).toFixed(2)) * 100;
  }

  return (
    <div
      className={`mx-auto px-[12px] pt-[12px] mt-[12px] rounded-lg bg-white w-[351px] pb-[12px]`}
    >
      <Popup visible={popup} closeIconPosition="bottom">
        <div className="flex flex-col items-center">
          <LevelRule isCurrentDate={isCurrentDate} title={ruletitle} data={getConfig()}></LevelRule>
          <div
            onClick={() => setP(false)}
            className="w-[36px] h-[36px] bg-cover mt-[12px]"
            style={{ backgroundImage: `url(${require('asset/imgs/close.png')})` }}
          ></div>
        </div>
      </Popup>
      <Popup visible={popup2} closeIconPosition="bottom">
        <div className="flex flex-col items-center">
          <LevelProgress
            value={progressV.value}
            data={giftFlow}
            close={() => setP2(false)}
          ></LevelProgress>
        </div>
      </Popup>
      <div
        className="flex justify-between items-center text-[#333] font-sans text-base font-bold leading-5"
        dir="auto"
      >
        <span>{_T('数据中心')}</span>
        <div className="flex items-center">
          <div
            className="bg-cover w-[18px] h-[18px] mr-[3px]"
            style={{
              backgroundImage: `url(${require('asset/imgs/clock.png')})`,
            }}
          ></div>
          <CountDown time={countDown}>
            {(timeData) => (
              <span className="text-[#16B28D] text-[14px] font-[500]">
                <span>{String(timeData.days).padStart(2, '0')}</span>
                <span>:</span>
                <span>{String(timeData.hours).padStart(2, '0')}</span>
                <span>:</span>
                <span>{String(timeData.minutes).padStart(2, '0')}</span>
                <span>:</span>
                <span>{String(timeData.seconds).padStart(2, '0')}</span>
              </span>
            )}
          </CountDown>
        </div>
      </div>
      <div className="relative mt-[10px] w-[327px] h-[62px] rounded-lg bg-[#F5F7F7] flex justify-start items-center">
        <div className="ml-[12px] pt-[10px] flex flex-col justify-start items-start w-[101px] h-[62px] rounded-lg bg-[#F5F7F7]">
          <div className="text-[#B3B3B3] text-left font-sans text-[10px] font-semibold" dir="auto">
            {_T('总直播时长')}
          </div>
          <div className="text-[#16B28D] font-sans text-[16px] font-bold text-left" dir="auto">
            {sprintf(_T('{hour}小时'), {
              hour: formaTimeForTsToH(memberData?.masterLiveTime?.inVoiceTotal || 0),
            })}
          </div>
        </div>
        <div className="pt-[10px] ml-[65px] flex flex-col justify-start items-strat w-[101px] h-[62px] rounded-lg bg-[#F5F7F7]">
          <div className="text-[#B3B3B3] text-left font-sans text-[10px] font-semibold" dir="auto">
            {_T('>=2小时')}
          </div>
          <div className="text-[#16B28D] font-sans text-[16px] font-bold text-left" dir="auto">
            {sprintf(_T('{day}天'), {
              day: memberData?.masterLiveTime?.activeDayTotal || 0,
            })}
          </div>
        </div>
        <div className="w-[1px] h-[30px] bg-[#B3B3B3] absolute left-[50%] top-[50%] transfrom translate-x-[-50%] translate-y-[-50%]"></div>
        <div
          onClick={goToTime}
          className="absolute w-[18px] h-[18px] top-[50%] transform translate-y-[-50%] right-[12px] bg-cover"
          style={{
            backgroundImage: `url(${require('asset/imgs/right.png')})`,
          }}
        ></div>
      </div>
      {type === 'master' && (
        <div className="mt-[12px] flex justify-between">
          <Card name={_T('公会薪资')} value={'$' + (masterData?.totalSalary || 0)}></Card>
          <Card name={_T('公会长薪资')} value={'$' + (masterData?.masterSalary || 0)}></Card>
          <Card name={isCurrentDate ? _T('预估其他主播薪资') : _T('其他主播薪资')} value={'$' + (masterData?.anchorTotalSalary || 0)}></Card>
        </div>
      )}

      {type === 'member' && (
        <div className="mt-[12px] flex justify-between">
          <Card
            name={_T('总薪资')}
            value={
              '$' +
              ((memberData?.anchorCoinData?.anchorCoinSalary || 0) +
                (memberData?.anchorFlowSalary?.anchorGitFlowSalary || 0))
            }
          ></Card>
          <Card
            name={isCurrentDate ? _T('预估钻石薪资') : _T('钻石薪资')}
            value={'$' + (memberData?.anchorCoinData?.anchorCoinSalary || 0)}
            isQ={true}
            // qClick={() => changeRuleType('gift', _T('钻石薪资'))}
            qClick={() => changeRuleType('coin', isCurrentDate ? _T('预估钻石薪资') : _T('钻石薪资'))}
          ></Card>
          {/* <Card
            name={_T('钻石薪资')}
            value={isCurrentDate ? '~' : '$' + (memberData?.anchorCoinData?.anchorCoinSalary || 0)}
            isQ={true}
            qClick={() => changeRuleType('coin', _T('钻石薪资'))}
          ></Card> */}
          <Card
            name={_T('钻石余额')}
            // value={isCurrentDate ? '~' : (memberData?.anchorCoinData?.coinTotal || 0) / 100}
            value={(memberData?.anchorCoinData?.cleanCoin || 0) / 100}
          ></Card>
        </div>
      )}

      {type === 'master' && (
        <div className="mt-[12px] flex justify-between">
          <Card
            name={_T('公会长提成')}
            value={'$' + (masterData?.debuctMasterTotal || 0)}
            isQ={true}
            qClick={() => changeRuleType('salary', _T('公会长提成'))}
          ></Card>
          {/* <Card name={_T('公会长提成')} value={'$' + (memberData?.anchorFlowSalary?.masterDeduct || 0)} isQ={true} qClick={() => changeRuleType('salary', _T('公会长提成'))}></Card>  */}
          <Card
            name={isCurrentDate ? _T('预估钻石薪资') : _T('钻石薪资')}
            value={'$' + (memberData?.anchorCoinData?.anchorCoinSalary || 0)}
            // isQ={true}
            // qClick={() => changeRuleType('gift', _T('钻石薪资'))}
            isQ={true}
            qClick={() => changeRuleType('coin', _T('钻石薪资'))}
          ></Card>
          {/* <Card
            name={_T('钻石薪资')}
            value={isCurrentDate ? '~' : '$' + (memberData?.anchorCoinData?.anchorCoinSalary || 0)}
            // isQ={true}
            // qClick={() => changeRuleType('coin', _T('钻石薪资'))}
          ></Card> */}
          <Card
            name={_T('钻石余额')}
            value={(memberData?.anchorCoinData?.cleanCoin || 0) / 100}
          ></Card>
        </div>
      )}
      {isCurrentDate ? (
        // <div className="pt-[12px] pl-[12px] mt-[12px] relative flex flex-col items-start w-[327px] h-[84px] rounded-lg bg-[#F5F7F7]">
        //   <div className="flex items-center justify-between w-full" dir="auto">
        //     <div className="text-[#333] font-sans text-sm font-bold flex justify-center items-center" dir="auto" onClick={() => {
        //       if (process.env.REACT_APP_ENV === 'development') {
        //         window.location.href = `http://192.168.0.233/s-guild?token=${getArgFromUrl('token')}`;
        //       } else {
        //         window.location.href = `https://web.danachatapp.com/s-guild?token=${getArgFromUrl('token')}`;
        //       }
        //     }}>
        //       {_T('收到的钻石')}
        //       <div className='w-[16px] h-[16px] ml-[3px] bg-cover'
        //         style={{ backgroundImage: `url(${require('asset/imgs/gift-jump.png')})` }}></div>
        //     </div>
        //     <div
        //       onClick={() => setP2(true)}
        //       className="w-[18px] h-[18px] bg-cover mr-[10px]"
        //       style={{
        //         backgroundImage: `url(${require('asset/imgs/go.png')})`,
        //       }}
        //     ></div>
        //   </div>
        //   <div className="flex justify-between items-center mt-[12px] w-full pr-[12px]">
        //     <div
        //       className="text-[#16B28D] font-sans text-[14px] font-bold leading-[18px]"
        //       dir="auto"
        //     >
        //       Lv{progressV?.level || 0}
        //     </div>
        //     <div className="flex items-center justify-center">
        //       <div
        //         className="w-[16px] h-[13px] bg-cover"
        //         style={{
        //           backgroundImage: `url(${require('asset/imgs/coin.png')})`,
        //         }}
        //       ></div>
        //       <div
        //         className="text-[#FFB627] text-right font-sans text-[14px] font-bold leading-[18px]"
        //         dir="auto"
        //       >
        //         {progressV.value}/{progressV.nextValue}
        //       </div>
        //     </div>
        //   </div>
        //   <div className="w-[303px] mt-[6px]">
        //     <Progress
        //       percentage={getProgress()}
        //       pivotText={''}
        //       color="linear-gradient(90deg, #7DD97F 0%, #16B28D 100%)"
        //     />
        //   </div>
        // </div>
        <div></div>
      ) : (
        <div className="mt-[12px] flex justify-between">
          <Card
            type={'big'}
            name={_T('钻石薪资等级')}
            value={memberData?.anchorFlowSalary?.flowLv || 0}
          ></Card>
          <Card
            type={'big'}
            name={_T('收到的钻石')}
            value={
              memberData?.anchorFlowSalary?.giftFlowTotal
                ? memberData?.anchorFlowSalary?.giftFlowTotal / 100
                : 0
            }
          ></Card>
        </div>
      )}
      {/* <div className="mt-[12px] flex justify-between">
        <Card
          type={'big'}
          name={_T('钻石薪资等级')}
          value={isCurrentDate ? '~' : memberData?.anchorCoinData?.coinSalaryLv || 0}
        ></Card>
        <Card
          type={'big'}
          name={_T('清空钻石数')}
          value={isCurrentDate ? '~' : (memberData?.anchorCoinData?.coinTotal || 0) / 100}
        ></Card>
      </div> */}
      {/* Data Details 卡片 */}
      <div
        className="mt-[12px] flex justify-between items-center w-[327px] h-[48px] rounded-lg bg-[#F5F7F7] px-[12px] cursor-pointer"
        onClick={() => {
          navigate('/diamond-reward');
        }}
      >
        <span className="text-[#333] font-sans text-sm font-semibold">{_T('钻石流水&奖励')}</span>
        <div className="flex items-center">
          <div
            className="w-[16px] h-[13px] bg-cover mr-[4px]"
            style={{
              backgroundImage: `url(${require('asset/imgs/diamond.png')})`,
            }}
          ></div>
          <span className="text-[#333] font-sans text-sm font-semibold mr-[4px]">
            {(memberData?.anchorFlowSalary?.giftFlowTotal ?? 0) / 100}
          </span>
          <div
            className="w-[18px] h-[18px] bg-cover"
            style={{
              backgroundImage: `url(${require('asset/imgs/right.png')})`,
            }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default DataDetails;
